import { render, staticRenderFns } from "./management-organization-member-form.vue?vue&type=template&id=4616e75d"
import script from "./management-organization-member-form.vue?vue&type=script&lang=js"
export * from "./management-organization-member-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports